import React, { useState, useEffect } from 'react';
import BlockCard from '../../components/BlockCard';
import AboutLink from '../../components/AboutLink';

const UserPage: React.FC<{ gists: any[], userId: string, showHeader: boolean, showFooter: boolean }> = ({ gists, userId, showHeader, showFooter  }) => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const bodyStyle: React.CSSProperties = {
    marginRight: "0px",
    marginTop: "0px",
    marginBottom: "0px",
    marginLeft: "40px",
    backgroundColor: 'white',
    width: `${Math.max(windowSize.width, 960)}px`,
  };

  const html1Style: React.CSSProperties = {
    width: `${Math.max(windowSize.width, 1024)}px`,
    textAlign: 'left',
    overflowX: 'auto',
    overflowY: 'auto',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    position: 'relative',
    minHeight: '1087px',
    zIndex: 0,
  };

  const htmlStyle: React.CSSProperties = {
    textAlign: 'left',
    minWidth: '960px',
    overflowX: 'visible',
    overflowY: 'visible',
  };

  const bodyDivStyle: React.CSSProperties = {
    verticalAlign: 'bottom',
    minHeight: '1007px',
    color: 'rgb(0, 0, 0)',
    textAlign: 'left',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    position: 'relative',
    width: `${Math.max(windowSize.width, 960)}px`,
    overflowX: 'visible',
    overflowY: 'visible',
    margin: '1em auto 4em',
  };

  const h1Style: React.CSSProperties = {
    textAlign: 'left',
    fontSize: '64px',
    fontWeight: 300,
    letterSpacing: '-2px',
    textRendering: 'optimizeLegibility',
    color: 'rgb(85, 85, 85)',
    margin: '0.3em 0px 0.1em',
  };

  return (
    <div style={bodyStyle}>
      <div style={html1Style}>
        <div style={htmlStyle}>
          <div style={bodyDivStyle}>
            {showHeader && <header>
              about{' '}
              <AboutLink />
            </header>}
            <h1 style={h1Style}>
              <a
                href={`https://github.com/${userId}`}
                title={`View ${userId} on GitHub`}
                style={{ textDecoration: 'none', color: 'rgb(0, 0, 0)' }}
              >
                {userId}
              </a>
              's blocks
            </h1>
            <div>
                {gists.map((gist: any) => {
                    if (!gist) return null;
                    // if no thumbnail.png, then don't show it
                    if (!gist.files["thumbnail.png"]) return null;
                    // overwrite the user object with the userId
                    const blockGist = { ...gist, user: { login: userId } };
                    return <BlockCard key={gist.id} gist={blockGist} />
                })}
              <br style={{ clear: 'both' }} />
              {showFooter && <footer style={{ marginTop: '8em' }}>
                about{' '}
                <AboutLink />
              </footer>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPage;
